import React from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Option } from "../../ReactSelect/ReactSelect";
import NumberInput from "@me-team/common/src/components/Products/inputs/NumberInput";
import { ReactSelect } from "../../index";
import { ErrorMessage } from "formik";

interface InputBlockProps {
    name: string;
    placeholder: string;
    initialValue?: number;
    id: string;
    disabled?: boolean;
    allowZero?: boolean;
}

interface QuantityUnitInputProps {
    quantity: InputBlockProps;
    unit: InputBlockProps & {
        options: Option[];
        value: Option | null;
        onChange: (option: Option) => void;
        stylesSelect: any;
    };
    quantityWarnings: boolean;
}

const QuantityUnitInput: React.FC<QuantityUnitInputProps> = ({ quantity, unit, quantityWarnings }) => {
    const { t } = useTranslation();

    return (
        <Row>
            <Col xs={5} className="pe-0">
                <NumberInput
                    id={quantity.id}
                    name={quantity.name}
                    placeholder={t(quantity.placeholder)}
                    disabled={quantity.disabled}
                    maxLength={9}
                    combined={true}
                    quantityWarnings={quantityWarnings}
                    allowZero={quantity.allowZero}
                />
            </Col>
            <Col xs={7} className="ps-0">
                <ReactSelect
                    id={unit.id}
                    name={unit.name}
                    placeholder={t(unit.placeholder)}
                    disabled={unit.disabled}
                    isSearchable={false}
                    options={unit.options}
                    value={unit.value}
                    onChange={unit.onChange}
                    menuPortalTarget={document.body}
                    stylesSelect={unit.stylesSelect}
                />
                <ErrorMessage name={unit.name}>
                    {(msg) => <div className="invalid-feedback d-block text-start">{msg}</div>}
                </ErrorMessage>
            </Col>
        </Row>
    );
};

export default QuantityUnitInput;
